import Vue from 'vue'
// import axios from 'axios'

Vue.directive('log-click', {
  bind (el, binding) {
    el.addEventListener('click', function () {
      const fullUrl = window.location.href

      window.PRIME_VUE_OBJECT.$http.post('/api/admin-logs', {
        type: 'action',
        action: binding.value || 'button_click',
        request_url: fullUrl
      })
    })
  }
})

Vue.directive('decimal', {
  inserted (el, binding, vnode) {
    const cfg = Object.assign({ decimals: 2, allowNegative: false }, binding.value || {})

    const getInput = () => ((el.tagName && el.tagName.toLowerCase() === 'input') ? el : el.querySelector('input'))

    const setValue = (val) => {
      const input = getInput()
      if (!input) return
      input.value = val
      if (vnode.componentInstance) {
        vnode.componentInstance.$emit('input', val)
      } else {
        input.dispatchEvent(new Event('input', { bubbles: true }))
      }
    }

    const sanitize = (raw, keepTrailingDot = true) => {
      const rawStr = String(raw ?? '')
      // allow fully empty while typing
      if (rawStr === '') return ''

      let s = rawStr.replace(/[^\d.\-]/g, '')
      // if everything was stripped, keep empty
      if (s === '') return ''

      // sign
      let sign = ''
      if (cfg.allowNegative && s.startsWith('-')) sign = '-'
      s = s.replace(/-/g, '')

      const endsWithDot = s.endsWith('.')
      const [intRaw = '', ...rest] = s.split('.')

      let int = intRaw.replace(/^0+(?=\d)/, '') // trim leading zeros but keep "0" when needed
      let dec = rest.join('') // collapse extra dots

      if (cfg.decimals === 0) dec = ''
      if (dec.length > cfg.decimals) dec = dec.slice(0, cfg.decimals)

      // If user typed ".5" (no integer part), show "0.5" while typing; but if everything was cleared, return ''
      if (int === '' && (dec !== '' || endsWithDot)) {
        int = '0'
      } else if (int === '') {
        return '' // user cleared everything
      }

      const dot = ((endsWithDot && keepTrailingDot && cfg.decimals > 0) || dec) ? '.' : ''
      return sign + int + dot + dec
    }

    const attach = () => {
      const input = getInput()
      if (!input) return

      const onInput = (e) => {
        if (e.target.value === '') { setValue(''); return }
        const clean = sanitize(e.target.value, true)
        if (e.target.value !== clean) setValue(clean)
      }

      const onBlur = (e) => {
        const v = e.target.value
        if (v === '' || v === '-' || v === '.') { setValue(''); return }
        const num = Number(v)
        if (!Number.isFinite(num)) { setValue(''); return }
        setValue(cfg.decimals > 0 ? num.toFixed(cfg.decimals) : String(Math.trunc(num)))
      }

      input.addEventListener('input', onInput)
      input.addEventListener('blur', onBlur)
      input.addEventListener('paste', () => setTimeout(() => onInput({ target: input }), 0))
      input.addEventListener('drop',  () => setTimeout(() => onInput({ target: input }), 0))

      el._decimalCleanup = () => {
        input.removeEventListener('input', onInput)
        input.removeEventListener('blur', onBlur)
      }
    }

    vnode.context && vnode.context.$nextTick(attach)
  },
  unbind (el) {
    el._decimalCleanup && el._decimalCleanup()
  }
})
